import React from 'react'
import { useForm } from 'react-hook-form'
import { IconLogin } from '@tabler/icons-react'
import { useAuth } from '../../../Auth/AuthProvider'
import { Link, useNavigate } from 'react-router-dom'
import Spinner from '../../../Components/Spinner'

const fieldClass =
  'w-full border border-mauve-200 bg-white px-3 py-2 text-mauve-900 outline-none transition focus:border-mauve-500'

export default function LoginFormEmail(props) {
  const { register, handleSubmit } = useForm()
  const { loginWithEmail } = useAuth()
  const navigate = useNavigate()

  const loginUser = ({ loginEmail, loginPassword }) => {
    props.handleLogin('email', true)
    loginWithEmail(loginEmail, loginPassword)
      .then(() => {
        props.handleLogin('email', false)
        navigate(props.userHomePath)
      })
      .catch((err) => {
        props.handleLogin('email', false)
        props.handleError('email', err.message)
      })
  }

  return (
    <form onSubmit={handleSubmit(loginUser)} className="space-y-3">
      <input
        {...register('loginEmail')}
        className={fieldClass}
        placeholder="Email"
        type="email"
        defaultValue=""
      />
      <div>
        <input
          {...register('loginPassword')}
          className={fieldClass}
          placeholder="Password"
          type="password"
          defaultValue=""
        />
        <div className="mt-1 text-right text-xs text-mauve-500">
          <Link to="/forgotPassword" className="text-mauve-600 hover:text-mauve-800">
            Forgot password?
          </Link>
        </div>
      </div>
      {props.error ? (
        <p className="text-sm text-red-600">{props.error}</p>
      ) : null}
      <button
        type="submit"
        className="flex w-full items-center justify-center gap-2 bg-mauve-800 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-mauve-900"
      >
        {props.loggingIn ? (
          <Spinner className="text-white" />
        ) : (
          <>
            <IconLogin className="size-4" />
            Sign in with email
          </>
        )}
      </button>
      <p className="text-sm italic text-mauve-500">
        Don't have an account?{' '}
        <Link to="/register" className="text-mauve-700 not-italic hover:text-mauve-900">
          Create one
        </Link>
      </p>
    </form>
  )
}
